export const createQuestion = (payload?: any) => ({
    type: "@saga/CREATE_QUESTION",
    payload
});

